import type { InvertedLocalize } from '../../../shared/hooks/use-invertedlocalize';

import {
  getHttp412ErrorResponseMessage,
  getQueryErrorHttpStatus,
} from './utils';

const REVIEW_STILL_IN_PROGRESS_MESSAGE =
  'Review is still in progress. Please come back later once review is completed.' as const;

export interface RequestReviewDetailsErrorDisplay {
  title: string;
  subtitle: string;
}

/**
 * Title and subtitle for {@link AuditLogMessages} when request-review-details query fails.
 */
export function getRequestReviewDetailsErrorDisplay(
  queryError: unknown,
  l: InvertedLocalize<string>
): RequestReviewDetailsErrorDisplay {
  const httpStatus = getQueryErrorHttpStatus(queryError);
  const isForbidden = httpStatus === 403;
  const reviewInProgressMessage = getHttp412ErrorResponseMessage(queryError);

  const title: string = isForbidden
    ? l('Access Denied')
    : l('Something went wrong');

  let subtitle: string;

  if (isForbidden) {
    subtitle = l(
      'You do not have permission to access this session. Request access from your administrator if you think this is a mistake.'
    );
  } else if (reviewInProgressMessage) {
    subtitle =
      reviewInProgressMessage === REVIEW_STILL_IN_PROGRESS_MESSAGE
        ? l(REVIEW_STILL_IN_PROGRESS_MESSAGE)
        : reviewInProgressMessage;
  } else {
    subtitle = l(
      'Try refreshing, or check back later. If the issue persists, contact your administrator.'
    );
  }

  return { title, subtitle };
}
